<div class="submission-poup-content">
  <div class="submission-card flex justify-content-between">
    <div class="gc-submission-user">
      <div *ngIf="!patientSubmission.unmatchedVisits" class="SU-avatar">
        <app-avatar
          [firstName]="patientSubmission?.firstName ? patientSubmission?.firstName : patientSubmission?.patient?.firstName"
          [lastName]="patientSubmission?.lastName ? patientSubmission?.lastName : patientSubmission?.patient?.lastName"
        ></app-avatar>
        <!-- <img src="{{ patientSubmission?.picture }}"> -->
      </div>
      <div
        *ngIf="!currentUser.is_super_admin && currentUser.currentUserRole != IOHAgencyAdminAdministrator && currentUser.currentUserRole != iohAdmin"
        class="SU-info"
      >
        <p>
          {{
            patientSubmission?.patientName
              ? patientSubmission?.patientName
              : patientSubmission?.patient.firstName + " " + patientSubmission?.patient?.lastName | removeHtml
          }}
        </p>
        <span>{{ patientSubmission?.mrn | removeHtml }}</span>
      </div>
      <div
        *ngIf="currentUser.is_super_admin || currentUser.currentUserRole == iohAdmin || currentUser.currentUserRole == IOHAgencyAdminAdministrator"
        class="SU-info"
      >
        <span>{{ patientSubmission?.patientId }}</span>
      </div>
    </div>
    <div class="submission-details">
      <div class="flex gap-4">
        <div class="align-items-center flex flex-column justify-content-center">
          <label for="">Visit Type:</label>
          <span>{{ patientSubmission?.visitType | removeHtml }}</span>
        </div>
        <div class="align-items-center flex flex-column justify-content-center">
          <label for="">Visit Date: </label>
          <span>{{
            patientSubmission?.visitDate
              ? (patientSubmission?.visitDate | date: dateFormat)
              : (patientSubmission?.submissionData?.visitDate | date: dateFormat)
          }}</span>
        </div>
        <div class="align-items-center flex flex-column justify-content-center" *ngIf="patientSubmission?.submissionData?.episodeVisitDate">
          <label for="">Episode: </label>
          <div>{{ patientSubmission?.submissionData?.episodeVisitDate | date: dateFormat }} -</div>
          <div>{{ patientSubmission?.submissionData?.episodeEndDate | date: dateFormat }}</div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="preQAIssuesExist else IssuesSection">
  <div *ngIf="!patientSubmission.unmatchedVisits">
    <div class="align-items-center flex justify-content-between py-5 bg-white sticky top-0 z-5">
      <h2 class="gc-form-heading cursor-pointer collapsible-header" (click)="toggleSection('preQaCheck')">
        <i class="pi" [ngClass]="collapsedSections.preQaCheck ? 'pi-chevron-right' : 'pi-chevron-down'"></i>
        Pre QA Check:
        <span class="">{{ normalIssues && normalIssues.length ? normalIssues.length : 0 }}</span>
      </h2>

      <div class="flex gap-3" *ngIf="!collapsedSections.preQaCheck">
        <!-- Selected All Button -->
        <button
          pButton
          (click)="selectAllPreQaRows()"
          class="p-button p-button-primary text-center button-sm w-auto"
        >
          <i class="pi pi-check-square mr-2"></i>
          Select All
        </button>
        <button
          pButton
          [disabled]="!selectedRows || selectedRows.length === 0"
          (click)="exportPreQaRowsToCsv()"
          class="p-button text-center button-sm w-auto"
          mat-menu-item
        >
          <i class="pi pi-download mr-2"></i>
          Export CSV
        </button>
      </div>

      <!-- commented by management as design changed -->
      <!-- <div class="flex gap-3" *ngIf="allowToUpdateVisit">
        <div class="flex gap-3 align-items-center">
          <button (click)="updateStatus('ACCEPT ALL', -1)" [hidden]="selectedRows?.length === 0" class="accept-btn">Reviewed All</button>
          <button (click)="updateStatus('RECHECK ALL', -1)" [hidden]="selectedRows?.length === 0" class="recheck-btn">Needs Correction All</button>
        </div>
        <div>
          <button
            pButton
            [loading]="reProcessLoading"
            (click)="reProcess()"
            class="p-button text-center button-sm w-auto"
            mat-menu-item
          >
            Reprocess
          </button>
        </div>
      </div> -->
    </div>

    <!-- Table  -->
    <div *ngIf="!collapsedSections.preQaCheck">
      <p-table [(selection)]="selectedRows" [value]="normalIssues" class="visitDetails-table">
      <ng-template pTemplate="header">
        <tr>
          <th id="checkboxVisitDetails">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th *ngIf="isRowVisible('Q No')" class="w-9rem" id="qNoVisitDetails">Question</th>
          <th *ngIf="isRowVisible('Description')" class="w-12rem" id="descriptionVisitDetails">Description</th>
          <th *ngIf="isRowVisible('Clinical Answer')" class="w-12rem" id="answerVisitDetails">Clinical Answer</th>
          <th *ngIf="isRowVisible('Suggested Answer')" class="w-12rem" id="suggestedAnswerVisitDetails">Suggested Answer</th>
          <th *ngIf="isRowVisible('Clinical Decision')" class="w-12rem" id="clinicalDecisionVisitDetails">Clinician Decision</th>
          <!-- <th *ngIf="isRowVisible('Ans Description')" class="w-15rem" id="ansDescriptionVisitDetails">Ans Description</th> -->
          <th *ngIf="isRowVisible('Alert Type')" class="" id="alertTypeVisitDetails">Alert Type</th>
          <th *ngIf="isRowVisible('Rationale')" class="w-20rem" id="rationaleVisitDetails">Rationale</th>
          <th *ngIf="isRowVisible('QA Review Status')" id="qaReviewStatusVisitDetails">QA Review Status</th>
          <th *ngIf="isRowVisible('Action')" id="actionVisitDetails">Action</th>
          <th *ngIf="isRowVisible('QA Notes')" id="qaNotesVisitDetails">QA Notes</th>
          <th class="w-3rem" id="multiSelectVisitDetails">
            <div class="gc-filter-TCOL visit-details-column-picker" (click)="$event.stopPropagation()">
              <img alt="vector.svg" src="../../../assets/images/vector.svg" />
              <p-multiSelect
                #selectRows
                (onChange)="onSelectedRowsChange()"
                [(ngModel)]="selectedRowsForVisit"
                [displaySelectedLabel]="false"
                [filter]="true"
                [options]="visibleRows"
                appendTo="body"
                [baseZIndex]="10001"
              >
                <ng-template pTemplate="header">
                  <span class="cursor-pointer close-icon" (click)="selectRows.hide()"><i class="pi pi-times"></i></span
                ></ng-template>
              </p-multiSelect>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template let-patientSubmissionIssues let-rowIndex="rowIndex" pTemplate="body">
        <tr [pSelectableRow]="patientSubmissionIssues" class="p-selectable-row">
          <td>
            <p-tableCheckbox [value]="patientSubmissionIssues"></p-tableCheckbox>
          </td>
          <td *ngIf="isRowVisible('Q No')">
            <span class="image-text">{{ patientSubmissionIssues?.question }}</span>
            <img
              *ngIf="showDollarSign && suggestions && suggestions[patientSubmissionIssues?.question]"
              src="../../../assets/images/dollar-icon.svg"
              alt=""
              class="dollar-icon"
            />
            <!-- <span

              class="px-2 color-gc-blue"
              >

              </span
            > -->
          </td>
          <td *ngIf="isRowVisible('Description')">
            {{ patientSubmissionIssues?.description }}
          </td>
          <td *ngIf="isRowVisible('Clinical Answer')">
            <span class="image-text">{{ patientSubmissionIssues?.selectedAnswers }}</span>
          </td>
          <td *ngIf="isRowVisible('Suggested Answer')">
            <span class="image-text">{{ patientSubmissionIssues?.suggestedAnswers }}</span>
          </td>
          <td *ngIf="isRowVisible('Clinical Decision')">
            <span class="image-text" [ngClass]="patientSubmissionIssues?.requiredCorrection ? 'accepted-ques' : 'rejected-ques'">{{ patientSubmissionIssues?.requiredCorrection ? 'Accepted' : 'Rejected' }}</span>
          </td>

          <!-- commented by management as design changed -->
          <!-- <td *ngIf="isRowVisible('Ans Description')">
            {{ patientSubmissionIssues?.answerDescription }}
          </td> -->
          <td *ngIf="isRowVisible('Alert Type')">
            <span class="image-text" [style.color]="visitDetailColors[getAlertType(patientSubmissionIssues?.alertType || '')]">{{
              getAlertType(patientSubmissionIssues?.alertType || '')
            }}</span>
          </td>
          <td *ngIf="isRowVisible('Rationale')">
            <span [innerHTML]="patientSubmissionIssues?.rationale" class="image-text"></span>
          </td>
          <td *ngIf="isRowVisible('QA Review Status')">
            <span class="p-column-title">QA Review Status</span>
            <span class="image-text" [style.color]="visitDetailColors[getLabelByValue(patientSubmissionIssues?.status)]">{{
              getLabelByValue(patientSubmissionIssues?.status)
            }}</span>
          </td>
          <td *ngIf="isRowVisible('Action')">
            <div class="flex align-items-center gap-3" *ngIf="allowToUpdateVisit && !(patientSubmissionIssues?.status === NEEDS_CORRECTION_STATUS)">
              <button *ngIf="patientSubmissionIssues?.status === NOT_ADDRESSED_STATUS" (click)="updateQaStatus(rowIndex, REVIEWED_STATUS)" class="btn-text accpt-text" [disabled]="updatingQaStatus">{{ PRE_QA_STATUS[REVIEWED_STATUS] }}</button>
              <button *ngIf="patientSubmissionIssues?.requiredCorrection && patientSubmissionIssues?.status === REVIEWED_STATUS" (click)="updateQaStatus(rowIndex, NEEDS_CORRECTION_STATUS)" class="btn-text recheck-text" [disabled]="updatingQaStatus">{{ PRE_QA_STATUS[NEEDS_CORRECTION_STATUS] }}</button>
            </div>
          </td>
          <td *ngIf="isRowVisible('QA Notes')">
            <div class="qa-notes-cell">
              <div *ngIf="editingQaNotesIndex !== rowIndex" class="qa-notes-display" (click)="startEditingQaNotes(rowIndex, patientSubmissionIssues)">
                <span class="image-text" [class.empty-text]="!patientSubmissionIssues?.qaNotes">
                  {{ patientSubmissionIssues?.qaNotes || 'Click to add QA note' }}
                </span>
                <i *ngIf="allowToUpdateVisit" class="pi pi-pencil qa-notes-edit-icon"></i>
              </div>
              <div *ngIf="allowToUpdateVisit && editingQaNotesIndex === rowIndex" class="qa-notes-edit">
                <textarea
                  [(ngModel)]="editingQaNotesValue"
                  class="qa-notes-textarea"
                  rows="3"
                  placeholder="Enter QA note..."
                ></textarea>
                <div class="qa-notes-actions">
                  <button class="qa-notes-save-btn p-button" (click)="saveQaNotes(rowIndex, patientSubmissionIssues)" [disabled]="savingQaNotes">
                    <i *ngIf="!savingQaNotes" class="pi pi-check"></i>
                    <i *ngIf="savingQaNotes" class="pi pi-spin pi-spinner"></i>
                    <span>{{ savingQaNotes ? 'Saving...' : 'Save' }}</span>
                  </button>
                  <button class="qa-notes-cancel-btn p-button btn-cancel" (click)="cancelEditingQaNotes()" [disabled]="savingQaNotes">
                    <i class="pi pi-times"></i> Cancel
                  </button>
                </div>
              </div>
            </div>
          </td>
          <td></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="10" style="text-align: center">
            <span><em class="pi pi-exclamation-circle mr-2"></em>No Pre QA check data Found</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </div>
    </div>
  </div>
  <ng-template #IssuesSection>
    <div *ngIf="!patientSubmission.unmatchedVisits">
    <div class="align-items-center flex justify-content-between py-5 bg-white sticky top-0 z-5">
      <h2 class="gc-form-heading cursor-pointer collapsible-header" (click)="toggleSection('errorsAndWarnings')">
        <i class="pi" [ngClass]="collapsedSections.errorsAndWarnings ? 'pi-chevron-right' : 'pi-chevron-down'"></i>
        Errors and Warnings:
        <span class="">{{ normalIssues && normalIssues.length ? normalIssues.length : 0 }}</span>
      </h2>
      <div *ngIf="allowToUpdateVisit && !collapsedSections.errorsAndWarnings" class="flex gap-3">
        <div class="flex gap-3 align-items-center">
          <button (click)="updateStatus('ACCEPT ALL', -1)" [hidden]="selectedRows?.length === 0" class="accept-btn">Accept All</button>
          <button (click)="updateStatus('RECHECK ALL', -1)" [hidden]="selectedRows?.length === 0" class="recheck-btn">Recheck All</button>
        </div>
        <div>
          <button
            (click)="reProcess()"
            [loading]="reProcessLoading"
            class="p-button text-center button-sm w-auto"
            mat-menu-item
            pButton
          >
            Reprocess
          </button>
        </div>
      </div>
    </div>

    <!-- Table  -->
    <div *ngIf="!collapsedSections.errorsAndWarnings">
    <p-table [(selection)]="selectedRows" [value]="normalIssues" class="visitDetails-table">
      <ng-template pTemplate="header">
        <tr>
          <th id="checkboxVisitDetails">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th *ngIf="isRowVisible('Q No')" class="w-9rem" id="qNoVisitDetails">Item</th>
          <th *ngIf="isRowVisible('Description')" class="w-12rem" id="descriptionVisitDetails">Description</th>
          <th *ngIf="isRowVisible('Answer')" class="w-12rem" id="answerVisitDetails">Answer</th>
          <th *ngIf="isRowVisible('Ans Description')" class="w-15rem" id="ansDescriptionVisitDetails">Ans Description</th>
          <th *ngIf="isRowVisible('Alert Type')" class="" id="alertTypeVisitDetails">Alert Type</th>
          <th *ngIf="isRowVisible('Message')" class="w-20rem" id="messageVisitDetails">Message</th>
          <th *ngIf="isRowVisible('Status')" id="statusVisitDetails">Status</th>
          <th *ngIf="isRowVisible('Action')" id="actionVisitDetails">Action</th>
          <th class="w-3rem" id="multiSelectVisitDetails">
            <div class="gc-filter-TCOL visit-details-column-picker" (click)="$event.stopPropagation()">
              <img alt="vector.svg" src="../../../assets/images/vector.svg" />
              <p-multiSelect
                #selectRows
                (onChange)="onSelectedRowsChange()"
                [(ngModel)]="selectedRowsForVisit"
                [displaySelectedLabel]="false"
                [filter]="true"
                [options]="visibleRows"
                appendTo="body"
                [baseZIndex]="10001"
              >
                <ng-template pTemplate="header">
                  <span (click)="selectRows.hide()" class="cursor-pointer close-icon"><i class="pi pi-times"></i></span
                ></ng-template>
              </p-multiSelect>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template let-patientSubmissionIssues let-rowIndex="rowIndex" pTemplate="body">
        <tr [pSelectableRow]="patientSubmissionIssues" class="p-selectable-row">
          <td>
            <p-tableCheckbox [value]="patientSubmissionIssues"></p-tableCheckbox>
          </td>
          <td *ngIf="isRowVisible('Q No')">
            <span class="image-text">{{ patientSubmissionIssues?.question }}</span>
            <img
              *ngIf="showDollarSign && suggestions && suggestions[patientSubmissionIssues?.question]"
              alt=""
              class="dollar-icon"
              src="../../../assets/images/dollar-icon.svg"
            />
            <!-- <span

              class="px-2 color-gc-blue"
              >

              </span
            > -->
          </td>
          <td *ngIf="isRowVisible('Description')">
            {{ patientSubmissionIssues?.questionDescription }}
          </td>
          <td *ngIf="isRowVisible('Answer')">
            <span class="image-text">{{ patientSubmissionIssues?.answers | replaceNegativeOne }}</span>
          </td>
          <td *ngIf="isRowVisible('Ans Description')">
            {{ patientSubmissionIssues?.answerDescription }}
          </td>
          <td *ngIf="isRowVisible('Alert Type')">
            <span [style.color]="visitDetailColors[getAlertType(patientSubmissionIssues?.type)]" class="image-text">{{
              getAlertType(patientSubmissionIssues?.type)
            }}</span>
          </td>
          <td *ngIf="isRowVisible('Message')">
            <span [innerHTML]="patientSubmissionIssues?.message" class="image-text"></span>
          </td>
          <td *ngIf="isRowVisible('Status')">
            <span class="p-column-title">Status</span>
            <span [style.color]="visitDetailColors[getLabelByValue(patientSubmissionIssues?.status)]" class="image-text">{{
              getLabelByValue(patientSubmissionIssues?.status)
            }}</span>
          </td>
          <td *ngIf="isRowVisible('Action')">
            <div *ngIf="allowToUpdateVisit" class="flex align-items-center gap-3">
              <button (click)="updateStatus('ACCEPT', rowIndex)" class="btn-text w-4rem accpt-text">Accept</button>
              <button (click)="updateStatus('RECHECK', rowIndex)" class="btn-text w-6rem recheck-text">Recheck</button>
            </div>
          </td>
          <td></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" style="text-align: center">
            <span><em class="pi pi-exclamation-circle mr-2"></em>No Errors & Warnings Found</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </div>
  </div>
  </ng-template>
  <!-- Hidden by management
  <div *ngIf="!patientSubmission.unmatchedVisits">
    <div class="py-5 bg-white sticky top-0 z-5 cw-heading">
      <h2 class="gc-form-heading cursor-pointer collapsible-header" (click)="toggleSection('postQaCheck')">
        <i class="pi" [ngClass]="collapsedSections.postQaCheck ? 'pi-chevron-right' : 'pi-chevron-down'"></i>
        Post QA Check:
        <span class="">{{ crossRulesIssuesCount ? crossRulesIssuesCount : 0 }}</span>
      </h2>
      <p *ngIf="!collapsedSections.postQaCheck">The listed pairs of items are not consistent in scores. Please review</p>

    </div>

    <div *ngIf="!collapsedSections.postQaCheck">
      <p-table [(selection)]="selectedRows" [value]="crossRulesIssues" class="visitDetails-table consistency-warnings">
      <ng-template pTemplate="header">
        <tr>
          <th class="AC-f">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th class="w-9rem" id="itemInconsistencies">Item</th>
          <th class="w-12rem" id="descriptionInconsistencies">Description</th>
          <th class="w-12rem" id="answerInconsistencies">Answer</th>
          <th class="AC-ans-desc" id="ansDescriptionInconsistencies">Ans Description</th>
          <th class="AC-status" id="statusInconsistencies">Status</th>
        </tr>
      </ng-template>
      <ng-template let-patientSubmissionIssues let-rowIndex="rowIndex" pTemplate="body">
        <ng-container *ngIf="patientSubmissionIssues?.normalizedList && patientSubmissionIssues?.normalizedList.length">
          <ng-container *ngFor="let item of patientSubmissionIssues?.normalizedList">
            <tr [pSelectableRow]="patientSubmissionIssues" class="p-selectable-row highlightRow">
              <td>
                <p-tableCheckbox [value]="patientSubmissionIssues"></p-tableCheckbox>
              </td>
              <td class="w-8rem">
                <span class="image-text">{{ item?.question }}</span>
              </td>
              <td>
                {{ item?.questionDescription }}
              </td>
              <td>
                <span class="image-text">{{ item?.answers | replaceNegativeOne }}</span>
              </td>
              <td>
                {{ item?.answerDescription }}
              </td>
              <td>
                <span class="p-column-title">Status</span>
                <span class="image-text" [style.color]="visitDetailColors[getLabelByValue(item?.status)]">{{ getLabelByValue(item?.status) }}</span>
              </td>
            </tr>
            <tr [pSelectableRow]="item" class="p-selectable-row highlightRow">
              <td></td>
              <td>
                <span class="image-text">{{ item?.normalizedElement?.question }}</span>
              </td>
              <td>
                {{ item?.normalizedElement?.questionDescription }}
              </td>
              <td>
                <span class="image-text">{{ item?.normalizedElement?.answers | replaceNegativeOne }}</span>
              </td>
              <td>
                {{ item?.normalizedElement?.answerDescription }}
              </td>
              <td></td>
            </tr>
            <tr>
              <td colspan="10" class="h-1rem p-0"></td>
            </tr>
          </ng-container>
        </ng-container>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" style="text-align: center">
            <span><em class="pi pi-exclamation-circle mr-2"></em>No OASIS Inconsistencies Found</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </div>
  </div>
-->
  <div class="align-items-center flex justify-content-between my-5">
    <h2 class="gc-form-heading cursor-pointer collapsible-header" (click)="toggleSection('chartingDetails')">
      <i class="pi" [ngClass]="collapsedSections.chartingDetails ? 'pi-chevron-right' : 'pi-chevron-down'"></i>
      Charting Details
    </h2>
  </div>
  <div *ngIf="!collapsedSections.chartingDetails">
    <p-table
      (onHeaderCheckboxToggle)="masterChangeCheckbox($event)"
      [value]="patientSubmission?.questionnaire ? patientSubmission?.questionnaire : patientSubmission?.submissionData?.questionnaire"
      class="visitDetails-table"
    >
    <ng-template pTemplate="header">
      <tr>
        <th class="w-390" id="question">Question</th>
        <th class="w-12rem" id="answer">Answer</th>
        <th class="w-2" id="answer">QA Recommendation</th>
        <th class="w-2" id="answer">Status</th>
        <th class="" id="answer">Rationale</th>
      </tr>
    </ng-template>
    <ng-template let-patientSubmissionQuestion let-rowIndex="rowIndex" pTemplate="body">
      <tr class="p-selectable-row">
        <td>
          <span class="image-text">{{ patientSubmissionQuestion?.question | removeHtml }}</span>
        </td>
        <td class="border-right-1">
          <span class="image-text">{{ patientSubmissionQuestion?.answer | replaceNegativeOne }}</span>
        </td>
        <td>
          <span
            *ngIf="
              patientSubmission?.submissionData?.correctionDetails &&
              patientSubmission?.submissionData?.correctionDetails[patientSubmissionQuestion?.question]
            "
            class="image-text"
            >{{ patientSubmission?.submissionData?.correctionDetails[patientSubmissionQuestion?.question]?.comment | replaceNegativeOne }}</span
          >
        </td>
        <td>
          <span
            *ngIf="
              patientSubmission?.submissionData?.correctionDetails &&
              patientSubmission?.submissionData?.correctionDetails[patientSubmissionQuestion?.question]
            "
            class="image-text"
            [class]="
              patientSubmission?.submissionData?.correctionDetails[patientSubmissionQuestion?.question]?.accepted === true
                ? 'accepted-ques'
                : 'rejected-ques'
            "
            >{{
              patientSubmission?.submissionData?.correctionDetails[patientSubmissionQuestion?.question]?.accepted === true ? "Accepted" : "Rejected"
            }}</span
          >
        </td>
        <td>
          <span
            *ngIf="
              patientSubmission?.submissionData?.correctionDetails &&
              patientSubmission?.submissionData?.correctionDetails[patientSubmissionQuestion?.question]
            "
            class="image-text"
            >{{ patientSubmission?.submissionData?.correctionDetails[patientSubmissionQuestion?.question]?.reason }}</span
          >
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" style="text-align: center">
          <span><em class="pi pi-exclamation-circle mr-2"></em>No Charting Details Found</span>
        </td>
      </tr>
      </ng-template>
    </p-table>
  </div>
  <div *ngIf="patientSubmission?.rawQuestionnaire || patientSubmission?.submissionData?.rawQuestionnaire; else nonOasisQuestionaire">
    <div class="align-items-center flex justify-content-between my-5" *ngIf="!currentUser.is_super_admin && currentUser.currentUserRole != iohAdmin">
      <h2 class="gc-form-heading cursor-pointer collapsible-header" (click)="toggleSection('additionalQuestions')">
        <i class="pi" [ngClass]="collapsedSections.additionalQuestions ? 'pi-chevron-right' : 'pi-chevron-down'"></i>
        Additional Questions
      </h2>
    </div>
    <div *ngIf="!collapsedSections.additionalQuestions">
      <p-table
        [value]="patientSubmission?.rawQuestionnaire || patientSubmission?.submissionData?.rawQuestionnaire | keyvalue"
        class="visitDetails-table oasis-QA"
      >
      <ng-template pTemplate="header">
        <tr class="p-selectable-row">
          <th class="w-390" id="questionVisits">Question</th>
          <th class="" id="answerVisits">Answer</th>
          <th class="w-2" id="typeVisits">Type</th>
        </tr>
      </ng-template>
      <ng-template let-entry let-rowIndex="rowIndex" pTemplate="body">
        <tr>
          <td>
            <span class="image-text">{{ entry.key | replaceStringInHtml: "__" : " " }}</span>
          </td>
          <td>
            <span class="image-text">{{ entry.value.answers || entry.value  | replaceNegativeOne}}</span>
          </td>
          <td>
            <span class="image-text">{{ entry.value.type }}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" style="text-align: center">
            <span><em class="pi pi-exclamation-circle mr-2"></em>No Additional Details Found</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </div>
  </div>

  <ng-template #nonOasisQuestionaire>
    <div *ngIf="!currentUser.is_super_admin && currentUser.currentUserRole != iohAdmin">
      <div class="align-items-center flex justify-content-between my-5">
        <h2 class="gc-form-heading cursor-pointer collapsible-header" (click)="toggleSection('nonOasisQuestionnaire')">
          <i class="pi" [ngClass]="collapsedSections.nonOasisQuestionnaire ? 'pi-chevron-right' : 'pi-chevron-down'"></i>
          Non Oasis Questionnaire
        </h2>
      </div>
      <div *ngIf="!collapsedSections.nonOasisQuestionnaire">
        <p-table
          [value]="patientSubmission?.nonOasisQuestionnaire || patientSubmission?.submissionData?.nonOasisQuestionnaire | keyvalue"
          class="visitDetails-table oasis-QA"
        >
        <ng-template pTemplate="header">
          <tr class="p-selectable-row">
            <th class="w-390" id="questionVisits">Question</th>
            <th class="w-5" id="answerVisits">Answer</th>
            <th class="" id="typeVisits">Type</th>
          </tr>
        </ng-template>
        <ng-template let-entry let-rowIndex="rowIndex" pTemplate="body">
          <tr>
            <td>
              <span class="image-text">{{ entry.value.question }}</span>
            </td>
            <td>
              <span class="image-text">{{ entry.value.answer }}</span>
            </td>
            <td>
              <span class="image-text">{{ entry.value.type }}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" style="text-align: center">
              <span><em class="pi pi-exclamation-circle mr-2"></em>No Non Oasis Questionnaire Found</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
      </div>
    </div>
  </ng-template>

  <!-- <div class="button-container">
    <button pButton class="btn-cancel" (click)="closeSideBar.emit()">Close</button>
    <div *ngIf="!patientSubmission.unmatchedVisits" class="esco-updload-btn">
      <button pButton class="white-space-nowrap" (click)="eSOCUploadDisplay.emit()">
        <img src="/assets/images/upload.svg"> Upload eDOC</button>
    </div>
  </div> -->
</div>
